import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SecurityIcon from '@mui/icons-material/Security';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const WhatToExpectSection = () => {
  const outcomes = [
    {
      icon: SecurityIcon,
      title: "Lower Risk",
      description: "Reduce portfolio volatility and dividend cut risk through better diversification and systematic analysis of each holding's financial health.",
      stat: "Risk Reduction",
      value: "-35%",
    },
    {
      icon: MonetizationOnIcon,
      title: "Higher Income",
      description: "Optimize your dividend income by identifying high-quality dividend growth stocks and maintaining the right position sizes.",
      stat: "Dividend Growth",
      value: "+12%",
    },
    {
      icon: TrendingUpIcon,
      title: "Better Returns",
      description: "Achieve superior total returns through a balanced approach to dividend yield and growth potential, backed by quantitative analysis.",
      stat: "Total Returns",
      value: "+15%",
    },
  ];

  const OutcomeCard = ({ outcome }) => {
    const Icon = outcome.icon;
    
    return (
      <Box
        sx={{
          p: 4,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-8px)',
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: 'primary.main',
            borderRadius: '50%',
            p: 2,
            mb: 3,
          }}
        >
          <Icon sx={{ fontSize: 40, color: 'white' }} />
        </Box>

        <Typography variant="h4" gutterBottom fontWeight="bold" color="white">
          {outcome.title}
        </Typography>

        <Typography variant="h3" color="primary.main" sx={{ mb: 2, fontWeight: 'bold' }}>
          {outcome.value}
        </Typography>

        <Typography variant="subtitle1" color="grey.400" sx={{ mb: 2 }}>
          {outcome.stat}
        </Typography>

        <Typography variant="body1" color="grey.400" sx={{ flexGrow: 1 }}>
          {outcome.description}
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      id="resultsSection"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: '#1a1a1a', // Dark background
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 2,
            fontWeight: 'bold',
            color: 'white',
          }}
        >
          What to Expect
        </Typography>

        <Typography
          variant="h5"
          align="center"
          color="grey.400"
          sx={{ mb: 8, maxWidth: 800, mx: 'auto' }}
        >
          Our users typically see these improvements after implementing DivScore's recommendations
        </Typography>

        <Grid container spacing={4}>
          {outcomes.map((outcome) => (
            <Grid item xs={12} md={4} key={outcome.title}>
              <OutcomeCard outcome={outcome} />
            </Grid>
          ))}
        </Grid>

        <Typography
          variant="caption"
          align="center"
          sx={{
            display: 'block',
            mt: 4,
            color: 'grey.400',
          }}
        >
          * Results based on average user portfolio performance over 12 months
        </Typography>
      </Container>
    </Box>
  );
};

export default WhatToExpectSection;